import { useEffect, useReducer } from 'react';

import Pill from '@ingka/pill';
import filterIcon from '@ingka/ssr-icon/paths/filters';
import { translate } from '@repo/phrase';

import { AllFiltersModal } from '@/components/filters/all-filters/all-filters-modal';

import { useResponsive } from '@/hooks/responsive.hooks';

import styles from './styles.module.scss';

export const AllFilters = () => {
    const { isDesktop } = useResponsive();
    const [visible, toggleVisible] = useReducer((visible) => !visible, false);

    useEffect(() => {
        // Cancel out the modal when resized to desktop
        if (isDesktop && visible) {
            toggleVisible();
        }
    }, [isDesktop, visible]);

    return (
        <div className={styles.all_filters}>
            <Pill size="small" label={translate('filter_all')} leadingIcon={filterIcon} onClick={toggleVisible} />
            <AllFiltersModal visible={visible} toggleVisible={toggleVisible} />
        </div>
    );
};
